/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { MxCallFragmentDoc } from '../../mx-calls/MxCallListItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectOverviewMxCallsBoxQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectOverviewMxCallsBoxQuery = { mxCalls: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'MxCallsConnection', totalCount: number, edges: Array<{ __typename: 'MxCallEdge', node: { __typename: 'MxCall', id: string, incomingNumber: string, outgoingNumber: string, isProcessed: boolean, startTime: any, endTime: any, type?: Types.MxCallType | null, status?: Types.MxCallStatus | null, source?: Types.MxCallSource | null, crmCompany?: { __typename: 'CrmCompany', id: string, title: string, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null } | null, category?: { __typename: 'Category', id: string, name: string } | null } }> } };


export const ProjectOverviewMxCallsBoxDocument = gql`
    query ProjectOverviewMxCallsBox($projectId: ID!) {
  mxCalls(
    filters: {projectId: $projectId}
    limit: 10
    sorting: [{column: startTime, direction: desc}]
  ) {
    ... on MxCallsConnection {
      edges {
        node {
          ...MxCall
        }
      }
      totalCount
    }
  }
}
    ${MxCallFragmentDoc}`;

/**
 * __useProjectOverviewMxCallsBoxQuery__
 *
 * To run a query within a React component, call `useProjectOverviewMxCallsBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOverviewMxCallsBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOverviewMxCallsBoxQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectOverviewMxCallsBoxQuery(baseOptions: Apollo.QueryHookOptions<ProjectOverviewMxCallsBoxQuery, ProjectOverviewMxCallsBoxQueryVariables> & ({ variables: ProjectOverviewMxCallsBoxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOverviewMxCallsBoxQuery, ProjectOverviewMxCallsBoxQueryVariables>(ProjectOverviewMxCallsBoxDocument, options);
      }
export function useProjectOverviewMxCallsBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOverviewMxCallsBoxQuery, ProjectOverviewMxCallsBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOverviewMxCallsBoxQuery, ProjectOverviewMxCallsBoxQueryVariables>(ProjectOverviewMxCallsBoxDocument, options);
        }
export function useProjectOverviewMxCallsBoxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectOverviewMxCallsBoxQuery, ProjectOverviewMxCallsBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectOverviewMxCallsBoxQuery, ProjectOverviewMxCallsBoxQueryVariables>(ProjectOverviewMxCallsBoxDocument, options);
        }
export type ProjectOverviewMxCallsBoxQueryHookResult = ReturnType<typeof useProjectOverviewMxCallsBoxQuery>;
export type ProjectOverviewMxCallsBoxLazyQueryHookResult = ReturnType<typeof useProjectOverviewMxCallsBoxLazyQuery>;
export type ProjectOverviewMxCallsBoxSuspenseQueryHookResult = ReturnType<typeof useProjectOverviewMxCallsBoxSuspenseQuery>;
export type ProjectOverviewMxCallsBoxQueryResult = Apollo.QueryResult<ProjectOverviewMxCallsBoxQuery, ProjectOverviewMxCallsBoxQueryVariables>;